import { useQueryClient } from '@tanstack/react-query';

import { libraryKeys } from '@/shared/features/quiz-library/api/library.keys';
import { myQuizListKey } from '@/shared/features/quiz-list/hooks';

import type { Folder } from '../../types/folder.types';
import { folderKeys } from '../folder.keys';

/**
 * 폴더를 바꾼 뒤 관련 조회를 맞춘다.
 *
 * ⚠️ **뮤테이션 응답으로 상세 캐시를 덮어쓰지 않는다.** 생성·이동·이름·공개 변경 응답의
 * `items` 는 **미리보기 4개**라, 그대로 써넣으면 20개씩 읽어 둔 상세 목록이 4개로 잘린다.
 * 대신 무효화해서 커서를 처음부터 다시 받는다.
 */
export const useSyncFolder = () => {
  const queryClient = useQueryClient();
  return (folder: Folder) => {
    void queryClient.invalidateQueries({
      queryKey: folderKeys.detail(folder.id),
    });
    void queryClient.invalidateQueries({ queryKey: folderKeys.lists() });
    // 공개 폴더는 자료실 혼합 목록에도 나온다. 이름·공개범위·아이템이 바뀌면 그쪽도 낡는다.
    void queryClient.invalidateQueries({ queryKey: libraryKeys.all });
    // 이름·소속·공개 상태는 내 퀴즈 카드와 rootOnly 결과에도 반영돼야 한다.
    void queryClient.invalidateQueries({ queryKey: myQuizListKey });
  };
};
